export default __webpack_public_path__ + "static/media/Background_00211.0078b8bd.png";